function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 64.5391,
  cy: 59.811,
  r: 56.4609,
  fill: "#F1F3F9",
  stroke: "#D6DCE8",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8265 12.2689C18.2145 12.2689 20.9609 9.52244 20.9609 6.13447C20.9609 2.7465 18.2145 0 14.8265 0C11.4385 0 8.69202 2.7465 8.69202 6.13447C8.69202 9.52244 11.4385 12.2689 14.8265 12.2689Z",
  fill: "#EAEEF9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.3737 29.0504H56.2972V17.6362H95.7227C95.7952 17.6362 95.8677 17.6362 95.9401 17.6362C102.1 17.7816 107.101 22.8707 107.101 29.0504H94.0558",
  fill: "#F1F3F9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M86.3737 29.0504H56.2972V17.6362H95.7227C95.7952 17.6362 95.8677 17.6362 95.9401 17.6362C102.1 17.7816 107.101 22.8707 107.101 29.0504H94.0558H86.3737Z",
  stroke: "#D6DCE8",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M96.8097 17.6362C94.4906 17.7816 92.3164 18.7268 90.7944 20.3262C90.6495 20.4716 90.5045 20.617 90.3596 20.8351C88.9826 22.4345 87.968 24.5429 87.968 26.7966V94.6999C87.968 101.025 82.8948 106.114 76.5897 106.114H21.22V26.2877C21.365 23.9613 22.2347 21.8529 23.7566 20.3262C25.4235 18.6541 27.6702 17.6362 30.2067 17.6362H85.9387H96.5198C96.5923 17.6362 96.6648 17.6362 96.8097 17.6362Z",
  fill: "white",
  stroke: "#D6DCE8",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9521 33.1942H60.5006C59.9208 33.1942 59.4135 32.6853 59.4135 32.1037C59.4135 31.5221 59.9208 31.0132 60.5006 31.0132H76.9521C77.5319 31.0132 78.0392 31.5221 78.0392 32.1037C78.0392 32.6853 77.6043 33.1942 76.9521 33.1942Z",
  fill: "#AAB2C5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M52.746 33.1942H31.2939C30.7141 33.1942 30.2068 32.6853 30.2068 32.1037C30.2068 31.5221 30.7141 31.0132 31.2939 31.0132H52.8185C53.3983 31.0132 53.9056 31.5221 53.9056 32.1037C53.9056 32.6853 53.3983 33.1942 52.746 33.1942Z",
  fill: "#D6DCE8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.5159 43.954H45.1362C44.5564 43.954 44.0491 43.4451 44.0491 42.8635C44.0491 42.2819 44.5564 41.7729 45.1362 41.7729H66.5159C67.0957 41.7729 67.603 42.2819 67.603 42.8635C67.6754 43.4451 67.1681 43.954 66.5159 43.954Z",
  fill: "#AAB2C5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2513 43.954H31.2939C30.7141 43.954 30.2068 43.4451 30.2068 42.8635C30.2068 42.2819 30.7141 41.7729 31.2939 41.7729H38.2513C38.8311 41.7729 39.3384 42.2819 39.3384 42.8635C39.3384 43.4451 38.8311 43.954 38.2513 43.954Z",
  fill: "#D6DCE8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M76.9521 54.7143H63.8344C63.2546 54.7143 62.7473 54.2053 62.7473 53.6237C62.7473 53.0421 63.2546 52.5332 63.8344 52.5332H76.9521C77.5319 52.5332 78.0392 53.0421 78.0392 53.6237C78.0392 54.2053 77.6044 54.7143 76.9521 54.7143Z",
  fill: "#D6DCE8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5292 54.7143H31.2939C30.7141 54.7143 30.2068 54.2053 30.2068 53.6237C30.2068 53.0421 30.7141 52.5332 31.2939 52.5332H57.5292C58.109 52.5332 58.6163 53.0421 58.6163 53.6237C58.6163 54.2053 58.1815 54.7143 57.5292 54.7143Z",
  fill: "#AAB2C5"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M66.5158 65.474H52.0936C51.5138 65.474 51.0065 64.9651 51.0065 64.3835C51.0065 63.8019 51.5138 63.293 52.0936 63.293H66.5158C67.0956 63.293 67.6029 63.8019 67.6029 64.3835C67.6754 64.9651 67.1681 65.474 66.5158 65.474Z",
  fill: "#AAB2C5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7886 65.474H31.2939C30.7141 65.474 30.2068 64.9651 30.2068 64.3835C30.2068 63.8019 30.7141 63.293 31.2939 63.293H45.861C46.4408 63.293 46.9481 63.8019 46.9481 64.3835C46.9481 64.9651 46.4408 65.474 45.7886 65.474Z",
  fill: "#D6DCE8"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M76.952 76.2338H66.8782C66.2985 76.2338 65.7911 75.7249 65.7911 75.1433C65.7911 74.5616 66.2985 74.0527 66.8782 74.0527H76.952C77.5318 74.0527 78.0391 74.5616 78.0391 75.1433C78.0391 75.7249 77.6043 76.2338 76.952 76.2338Z",
  fill: "#AAB2C5"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M60.3557 76.2338H43.4694C42.8896 76.2338 42.3823 75.7249 42.3823 75.1433C42.3823 74.5616 42.8896 74.0527 43.4694 74.0527H60.3557C60.9354 74.0527 61.4428 74.5616 61.4428 75.1433C61.4428 75.7249 60.9354 76.2338 60.3557 76.2338Z",
  fill: "#D6DCE8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1642 76.2338H31.2939C30.7141 76.2338 30.2068 75.7249 30.2068 75.1433C30.2068 74.5616 30.7141 74.0527 31.2939 74.0527H37.1642C37.744 74.0527 38.2513 74.5616 38.2513 75.1433C38.2513 75.7249 37.744 76.2338 37.1642 76.2338Z",
  fill: "#AAB2C5"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M66.5158 86.9935H56.5145C55.9347 86.9935 55.4274 86.4846 55.4274 85.903C55.4274 85.3214 55.9347 84.8125 56.5145 84.8125H66.5158C67.0956 84.8125 67.6029 85.3214 67.6029 85.903C67.6754 86.4846 67.1681 86.9935 66.5158 86.9935Z",
  fill: "#AAB2C5"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9195 86.9935H31.2939C30.7141 86.9935 30.2068 86.4846 30.2068 85.903C30.2068 85.3214 30.7141 84.8125 31.2939 84.8125H49.9195C50.4993 84.8125 51.0066 85.3214 51.0066 85.903C51.0066 86.4846 50.4993 86.9935 49.9195 86.9935Z",
  fill: "#D6DCE8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2386 97.0991H66.8783C66.8783 99.571 67.8929 101.825 69.4873 103.424C71.0817 105.096 73.3284 106.041 75.7925 106.041H9.91422C7.45013 106.041 5.20345 105.024 3.60904 103.424C2.01463 101.825 1 99.571 1 97.0991H44.3391C44.3391 97.0991 52.3836 97.1718 52.2386 97.0991Z",
  fill: "#F1F3F9",
  stroke: "#D6DCE8",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M115.087 90.1366L105.936 80.9933L108.034 78.8955L117.177 88.0461L115.087 90.1366Z",
  fill: "#D6DCE8",
  stroke: "#AAB2C5",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M118.267 93.3538L111.251 86.3371C110.665 85.7512 110.665 84.7964 111.251 84.2104C111.837 83.6245 112.792 83.6245 113.377 84.2104L120.394 91.2271C120.98 91.813 120.98 92.7678 120.394 93.3538C119.808 93.9397 118.853 93.9397 118.267 93.3538Z",
  fill: "#858B9B"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M117.768 93.8022L108.741 84.7746C108.531 84.5648 108.531 84.2248 108.741 84.0078L111.048 81.7003C111.258 81.4905 111.598 81.4905 111.815 81.7003L120.843 90.7279C121.052 90.9377 121.052 91.2776 120.843 91.4946L118.535 93.8022C118.318 94.012 117.978 94.012 117.768 93.8022Z",
  fill: "#D6DCE8",
  stroke: "#AAB2C5",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5774 51.5308C86.0001 51.5308 78.2384 59.2925 78.2384 68.8698C78.2384 78.4399 86.0001 86.2088 95.5702 86.2088C105.148 86.2088 112.909 78.4471 112.909 68.8698C112.909 59.2925 105.148 51.5308 95.5774 51.5308ZM95.5774 82.9971C87.8881 82.9971 81.6599 76.6677 81.6599 68.8626C81.6599 61.0575 87.8881 54.7353 95.5774 54.7353C103.267 54.7353 109.495 61.0647 109.495 68.8698C109.495 76.6749 103.26 82.9971 95.5774 82.9971Z",
  fill: "#D6DCE8",
  stroke: "#AAB2C5",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

function SvgListNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 118,
    viewBox: "0 0 122 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNoData);
export default __webpack_public_path__ + "static/media/list-no-data.43c3232e.svg";
export { ForwardRef as ReactComponent };